import React, { useLayoutEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';

export default function CenteredGoogleLogin(props) {
  const container = useRef(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const element = container.current;
    const measure = () => setWidth(Math.min(400, Math.floor(element.getBoundingClientRect().width)));
    measure();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', measure);
      return () => window.removeEventListener('resize', measure);
    }
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return <Box ref={container} sx={{ width: '100%', maxWidth: 400, mx: 'auto', minHeight: 40, display: 'flex', justifyContent: 'center' }}>
    {width > 0 && <GoogleLogin {...props} width={String(width)} />}
  </Box>;
}
